import { render } from "./Admin.vue?vue&type=template&id=ce872838&scoped=true&ts=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=ce872838&lang=scss&scoped=true"
import "./Admin.vue?vue&type=style&index=1&id=ce872838&lang=scss"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce872838"]])

export default __exports__